// extracted by mini-css-extract-plugin
module.exports = {"content":"Box_content__3Z_iu","divider":"Box_divider__q_CVg"};